import React from 'react';
import { Stack, Skeleton } from '@metarouter-private/mr-mui';

export default function TagsSkeleton() {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Skeleton variant="rounded" width={60} height={24} />
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="circular" width={28} height={28} />
    </Stack>
  );
}
